
<div class="error-summary"></div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{ 'sgpRegEmailLabel' | translate:translations }}</mat-label>
    <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.userName" name="username"
      [disabled]="true" />
      <mat-hint>{{ 'regFormEmailHint' | translate:translations }}</mat-hint>

    </mat-form-field>
    <div class="mb-10"></div>
  </div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ 'regFormDisplayName' | translate:translations }}</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.displayName" name="dname" />
      <mat-hint>{{ 'regFormDisplayNameHint' | translate:translations }}</mat-hint>
    </mat-form-field>
    @if (isSubmitted && createuserobj.displayName=='') {
      <mat-error class="registration-validation-error">{{ 'regFormDisplayNameRequired' | translate:translations }}</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ 'regFormAge' | translate:translations }}</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.age" name="age" type="number" />
      <mat-hint>{{ 'regFormAgeHint' | translate:translations }}</mat-hint>
    </mat-form-field>
    @if (isSubmitted && createuserobj.age==0) {
      <mat-error class="registration-validation-error" >{{ 'regFormAgeRequired' | translate:translations }}</mat-error>
    }
    <div class="mb-10"></div>
  </div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ 'regFormPassword' | translate:translations }}</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.password" name="password" type="{{revealNewPassword ? 'text' : 'password'}}" autocomplete="new-password" />
      <button mat-icon-button matSuffix (click)="revealNewPassword = !revealNewPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealNewPassword" type="button">
        <mat-icon>{{revealNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-hint>{{ 'regFormPasswordHint' | translate:translations }}</mat-hint>
    </mat-form-field>
    @if (isSubmitted && createuserobj.password=='') {
      <mat-error class="registration-validation-error" >{{ 'regFormPasswordRequired' | translate:translations }}</mat-error>
    }
    @if (isSubmitted && !checkPasswordRequirements()) {
      <mat-error class="registration-validation-error" >{{ 'regFormPasswordInvalid' | translate:translations }}</mat-error>
    }
    <div class="mb-10"></div>
  </div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ 'regFormVerifyPassword' | translate:translations }}</mat-label>
      <input matInput class="form-control-textbox" name="verifypassword" [(ngModel)]="confirmPassword" type="{{revealConfirmPassword ? 'text' : 'password'}}" />
      <button mat-icon-button matSuffix (click)="revealConfirmPassword = !revealConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealConfirmPassword" type="button">
        <mat-icon>{{revealConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>

      <mat-hint>{{ 'regFormVerifyPasswordHint' | translate:translations }}</mat-hint>
    </mat-form-field>
    @if (isSubmitted && (confirmPassword=='' || confirmPassword != createuserobj.password)  ) {
      <mat-error class="registration-validation-error" >{{ 'regFormPasswordMismatch' | translate:translations }}</mat-error>
    }
    <div class="mb-10"></div>
  </div>

  <div class="form-fields">
    <div class="terms-conditions">
      <input type="checkbox" [(ngModel)]="termsAndConditionsCheck" name="termsandconditions"> &nbsp; {{ 'regFormTermsAgree' | translate:translations }}<br/>
      <mat-hint>{{ 'regFormTermsHint' | translate:translations }}</mat-hint>
    </div>
    <div class="mb-10"></div>
    @if (isSubmitted && !termsAndConditionsCheck) {
      <mat-error class="registration-validation-error" >{{ 'regFormTermsRequired' | translate:translations }}</mat-error>
    }
  </div>

  <div class="form-fields">
    <div class="terms-conditions">
      <input type="checkbox" [(ngModel)]="statementCheck" name="statement"> &nbsp; {{ 'regFormStatementsAgree' | translate:translations }}
      <ol>
        <li>{{ 'regFormStatement1' | translate:translations }}</li>
        <li>{{ 'regFormStatement2' | translate:translations }}</li>
      </ol>
    </div>
    @if (isSubmitted && !statementCheck) {
      <mat-error class="registration-validation-error" >{{ 'regFormStatementsRequired' | translate:translations }}</mat-error>
    }
  </div>
